module.exports = __webpack_public_path__ + "img/topics4.18972a55.jpg";